import styles from "./styles.module.scss";

function Home() {
  return (
    <>
      <section>
        
      </section>
    </>
  );
}

export default Home;